import RepaymentInterestCalculationType from "@/models/Shared/RepaymentInterestCalculationType";

export default (val: RepaymentInterestCalculationType) => {
    let returnVal = "Undefined";
    switch (val) {
        case RepaymentInterestCalculationType.RepaymentPeriodocity:
            returnVal = "Repayment Periodocity"
            break;
        case RepaymentInterestCalculationType.ActualDays:
            returnVal = "Actual Days"
            break;
    }
    return returnVal;
}